/* Size guide drawer on the product page (snippets/size-guide-drawer.liquid).
   Opens from [data-size-guide-open], closes on the cross, the overlay and
   Escape. A row selects the matching size on the product page by clicking
   the theme's own size button, so price, URL and the add-to-cart button
   stay in sync. The add button submits the theme's product form. */
(function () {
  var UNIT_KEY = 'size-guide-unit';

  function readUnit() {
    try {
      return window.localStorage.getItem(UNIT_KEY) === 'in' ? 'in' : 'cm';
    } catch (error) {
      return 'cm';
    }
  }

  function writeUnit(unit) {
    try {
      window.localStorage.setItem(UNIT_KEY, unit);
    } catch (error) {
      /* storage unavailable */
    }
  }

  /* "67.0" -> "67", "67.5" -> "67,5" */
  function formatCm(cm) {
    return String(Number(cm)).replace('.', ',');
  }

  function toInches(cm) {
    var value = Math.round((Number(cm) / 2.54) * 10) / 10;
    return String(value).replace('.', ',');
  }

  class SizeGuideDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-size-guide-panel]');
      this.overlay = this.querySelector('[data-size-guide-overlay]');
      this.rows = Array.from(this.querySelectorAll('[data-size-guide-row]'));
      this.cta = this.querySelector('[data-size-guide-add]');
      this.ctaLabel = this.querySelector('[data-size-guide-cta-label]');
      this.ctaPrice = this.querySelector('[data-size-guide-cta-price]');
      this.productPage = this.closest('product-page');
      this.isOpen = false;

      this.overlay.addEventListener('click', () => this.close());
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-size-guide-close]')) return this.close();
        var unit = event.target.closest('[data-size-guide-unit]');
        if (unit) return this.setUnit(unit.dataset.sizeGuideUnit);
        var row = event.target.closest('[data-size-guide-row]');
        if (row && !row.disabled) return this.pick(row);
        if (event.target.closest('[data-size-guide-add]')) return this.add();
      });
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      };
      document.addEventListener('keydown', this.onKeydown);

      /* Triggers live outside this element, on the product page. */
      this.onTrigger = (event) => {
        var trigger = event.target.closest('[data-size-guide-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      };
      document.addEventListener('click', this.onTrigger);

      /* Follow size changes made on the product page. */
      this.onSizeClick = (event) => {
        if (event.target.closest('[data-option-type="choice"]')) {
          requestAnimationFrame(() => this.syncFromPage());
        }
      };
      document.addEventListener('click', this.onSizeClick);

      this.setUnit(readUnit(), true);
      this.syncFromPage();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onTrigger);
      document.removeEventListener('click', this.onSizeClick);
      document.documentElement.classList.remove('size-guide-open');
    }

    open(trigger) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = trigger || document.activeElement;
      this.classList.remove('is-closing');
      this.classList.add('is-open');
      document.documentElement.classList.add('size-guide-open');
      this.syncFromPage();
      requestAnimationFrame(() => this.panel.focus());
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.classList.add('is-closing');
      document.documentElement.classList.remove('size-guide-open');
      var done = () => {
        this.classList.remove('is-closing');
        this.panel.removeEventListener('transitionend', done);
      };
      this.panel.addEventListener('transitionend', done);
      setTimeout(done, 500);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    setUnit(unit, silent) {
      this.unit = unit === 'in' ? 'in' : 'cm';
      if (!silent) writeUnit(this.unit);
      this.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
        var active = button.dataset.sizeGuideUnit === this.unit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.querySelectorAll('[data-cm]').forEach((cell) => {
        var cm = cell.dataset.cm;
        if (cm === '') return;
        cell.textContent = this.unit === 'in' ? toInches(cm) : formatCm(cm);
      });
    }

    /* A row click selects the same size on the product page. */
    pick(row) {
      var sizeButton = document.querySelector(
        '[data-option-type="choice"][data-variant-id="' + row.dataset.variantId + '"]'
      );
      if (sizeButton && !sizeButton.disabled) sizeButton.click();
      this.markRow(row);
    }

    syncFromPage() {
      var pressed = document.querySelector('[data-option-type="choice"][aria-pressed="true"]');
      var row = pressed
        ? this.rows.find((candidate) => candidate.dataset.variantId === pressed.dataset.variantId)
        : null;
      this.markRow(row || null);
    }

    markRow(row) {
      this.rows.forEach((candidate) => {
        var active = candidate === row;
        candidate.classList.toggle('is-selected', active);
        candidate.setAttribute('aria-pressed', String(active));
      });
      if (!this.cta) return;
      if (!row) {
        this.cta.disabled = true;
        this.ctaLabel.textContent = this.cta.dataset.labelChoose;
        this.ctaPrice.textContent = '';
        return;
      }
      var available = row.dataset.available === 'true';
      this.cta.disabled = !available;
      this.ctaLabel.textContent = available
        ? this.cta.dataset.labelAdd.replace('[size]', row.dataset.size)
        : this.cta.dataset.labelSoldOut;
      this.ctaPrice.textContent = row.dataset.price || '';
    }

    add() {
      var form = document.querySelector('[data-product-form]');
      if (!form || this.cta.disabled) return;
      this.close();
      form.requestSubmit();
    }
  }

  if (!customElements.get('size-guide-drawer')) {
    customElements.define('size-guide-drawer', SizeGuideDrawer);
  }
})();
